import { createSlice, PayloadAction } from "@reduxjs/toolkit/react";
import { CreditState } from "./credit-state.interface";
import { updateCreditAvanseThunk } from "./thunks/update-credit-avanse.thunk";
import { initCreditThunk } from "./thunks/init-credit.thunk";
import { fetchShippingMethodsThunk } from "./thunks/fetch-shipping-methods.thunk";
import { createOrderThunk } from "./thunks/create-order.thunk";
import { sendPhoneCodeThunk } from "./thunks/send-phone-code.thunk";
import { CreditInterface, CreditMonthsInterface } from "../../interfaces/credit/credit.interface";
import { ShippingMethodInterface } from "../../interfaces/credit/shipping-method.interface";
import { TotalInterface } from "../../interfaces/credit/total.interface";
import { UserInterface } from "../../interfaces/credit/user.interface";
import { Subscription } from "../../interfaces/product/product.interface";

const initialState: CreditState = {
    productId: typeof window !== 'undefined' ? (window as any).product_id : 0,
    loader: false,
    error: '',
    isShowLogoutPopup: false,
    credits: [],
    selectCredit: null,
    selectMonth: null,
    selectSubscription: null,
    selectStarnetRegion: null,
    selectStarnetCity: null,
    selectStarnetAddress: null,

    additionalServices: [],
    products: {
        items: [],
        total: 0,
        specialTotal: 0,
    },
    totalProducts: '0',
    avanse: 0,
    page: 1,
    user: {
        firstName: '',
        lastName: '',
        idno: '',
        phone: '',
        email: '',
        birthday: ''
    },
    confirmedCode: '',
    confirmedPhone: '',
    temporaryPhone: '',
    shipping: {
        shippingMethods: [],
        selectShippingMethod: null,
        shippingPickup: '',
        shippingZone: '',
        shippingAddress: '',
        shippingCity: '',
        shippingCityId: ''
    },
    total: {
        total: 0,
        shippingTotal: 0,
        creditTotal: 0,
        extraTotal: 0
    },
    text :{
        termsAdverting: '',
        terms: '',
        validOffer: '',
        credit: '',
        avanse: '',
        advantages: '',
        continue: '',
        back: '',
        firstName: '',
        lastName: '',
        idno: '',
        phoneNumber: '',
        email: '',
        birthday: '',
        item: '',
        order: '',
        total: '',
        shipping: '',
        pay: '',
        createOrder: '',
        currency: '',
        extra: '',
        address: '',
        city: '',
        zone: '',
        commentary: '',
        receipt: '',
        ridicare: '',
        selectCredit: '',
        contact: '',
        sms: '',
        telephone: '',
        eMail: '',
        leiMonth: '',
        errorCall: ''
    },
    popup: {
        isOpen: false
    },
    startButtons: null,
    isShowConfirmedPhone: false,
    marketing: true,
    terms: false,
    contactMethod: '',
    contactError: false
};

const handleError = (state: CreditState, action: PayloadAction<any>) => {
    state.loader = false;
    state.error = action.payload;
};

const handleLoader = (state: CreditState) => {
    state.loader = true;
};

const handleRedirect = (state: CreditState, action: PayloadAction<any>) => {
    state.error = '';

    if (action.payload.redirect) {
        window.location.href = action.payload.redirect;
    }
};

const creditSlice = createSlice({
    name: 'credit',
    initialState,
    reducers: {
        setProductId: (state, action: PayloadAction<number>) => {
            state.productId = action.payload;
        },

        setCredit: (state, action: PayloadAction<CreditInterface>) => {
            const selectedCredit = action.payload;
            state.selectCredit = selectedCredit;

            const month = selectedCredit.months.find(
                m => m.id === state.selectMonth?.id
            ) || selectedCredit.months[0];

            state.selectMonth = month;

            if (month?.subscriptions && month.subscriptions.length > 0) {
                state.selectSubscription = month.subscriptions[0];
            } else {
                state.selectSubscription = null;
            }
        },

        setMonth: (state, action: PayloadAction<{ credit: CreditInterface, month: CreditMonthsInterface }>) => {
            const { credit, month } = action.payload;
            state.selectCredit = credit;
            state.selectMonth = month;
            state.additionalServices = [];
        },
        setAvanse: (state, action: PayloadAction<number>) => {
            state.avanse = action.payload;
        },
        toggleService: (state, action: PayloadAction<{ id: number, state: boolean }>) => {
            const { id, state: shouldAdd } = action.payload;
            const index = state.additionalServices.indexOf(id);

            if (shouldAdd && index === -1) {
                state.additionalServices.push(id);
            } else if (!shouldAdd && index !== -1) {
                state.additionalServices.splice(index, 1);
            }
        },
        nextPage: (state) => {
            state.page = Math.min(state.page + 1, 3);
        },
        prevPage: (state) => {
            state.page = Math.max(state.page - 1, 1);
        },
        saveUser: (state, action: PayloadAction<UserInterface>) => {
            state.user = action.payload;
        },
        setShippingMethod: (state, action: PayloadAction<ShippingMethodInterface>) => {
            state.shipping.selectShippingMethod = action.payload;

            state.shipping.shippingZone = '';
            state.shipping.shippingPickup = '';
            state.shipping.shippingCity = '';
            state.shipping.shippingCityId = '';
            state.shipping.shippingAddress = '';
        },
        setShippingZone: (state, action: PayloadAction<string>) => {
            state.shipping.shippingZone = action.payload;
        },
        setShippingPickup: (state, action: PayloadAction<string>) => {
            state.shipping.shippingPickup = action.payload;
        },
        setTotal: (state, action: PayloadAction<TotalInterface>) => {
            state.total = action.payload;
        },
        setAddress: (state, action: PayloadAction<string>) => {
            state.shipping.shippingAddress = action.payload;
        },
        setCity: (state, action: PayloadAction<string>) => {
            state.shipping.shippingCity = action.payload;
        },
        togglePopup: (state, action: PayloadAction<boolean>) => {
            state.popup.isOpen = action.payload;
            const html = document.getElementsByTagName('html');
            if(html && html.length) {
                const element = html.item(0);
                if(element) {
                    if(action.payload) {
                        element.classList.add('overflow-hidden');
                    } else {
                        element.classList.remove('overflow-hidden');
                    }
                }
            }
        },
        openCredit: (state, action: PayloadAction<{ id: number, month: number }>) => {
            const credit = state.credits.find(credit => credit.id === action.payload.id) || state.credits[0];
            if (credit) {
                const month = credit.months.find((month: any) => month.id === action.payload.month);
                state.selectCredit = credit;
                state.selectMonth = month || credit.months[0];
            }

            state.page = 1;
            state.popup.isOpen = true;

            const html = document.getElementsByTagName('html');
            if(html && html.length) {
                const element = html.item(0);
                if(element) {
                    element.classList.add('overflow-hidden');
                }
            }

            try {
                // @ts-ignore
                window.sendGtagEvent('mn_credit_click');
            } catch (e: any) {}
        },
        showConfirmedPhone: (state, action: PayloadAction<string>) => {
            state.isShowConfirmedPhone = true;
            state.temporaryPhone = action.payload;
        },
        changeConfirmedPhone: (state) => {
            state.isShowConfirmedPhone = false;
        },
        setConfirmedPhone: (state, action: PayloadAction<{ phone: string, code: string }>) => {
            state.isShowConfirmedPhone = false;
            state.confirmedPhone = action.payload.phone;
            state.confirmedCode = action.payload.code;
        },
        setMarketing: (state, action: PayloadAction<boolean>) => {
            state.marketing = action.payload;
            if(!action.payload) {
                state.terms = true;
            }
        },
        setContactMethod: (state, action: PayloadAction<string>) => {
            state.contactMethod = action.payload;
        },
        setTerms: (state, action: PayloadAction<boolean>) => {
            state.terms = action.payload;
        },
        setShipping: (state, action: PayloadAction<{ zone: string, cityId: string, pickup: string }>) => {
            state.shipping.shippingZone = action.payload.zone;
            state.shipping.shippingCityId = action.payload.cityId;
            state.shipping.shippingPickup = action.payload.pickup;
        },
        selectSubscription(state, action: PayloadAction<Subscription | null>) {
            state.selectSubscription = action.payload;
        },
        setStarnetRegion: (state, action: PayloadAction<string | null>) => {
            state.selectStarnetRegion = action.payload;
        },
        setStarnetCity: (state, action: PayloadAction<string | null>) => {
            state.selectStarnetCity = action.payload;
        },
        setStarnetAddress: (state, action: PayloadAction<string | null>) => {
            state.selectStarnetAddress = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(initCreditThunk.fulfilled, (state, action) => {
                const { credits, products, totalProducts, texts, startButtons } = action.payload;
                state.credits = credits;
                state.products = products;
                state.totalProducts = totalProducts;
                state.text = texts;
                state.startButtons = startButtons;
            })
            .addCase(updateCreditAvanseThunk.fulfilled, (state, action) => {
                // state.credits = action.payload;
                // const credit = state.credits.find(credit => credit.id === state?.selectCredit?.id);
                // if (credit) {
                //     const month = credit.months.find((month: any) => month.id === state?.selectMonth?.id);
                //     if(month) state.selectMonth = month;
                // }

                state.products = action.payload.products;
                state.credits = action.payload.credits;

                const credit = state.credits.find(c => c.id === state.selectCredit?.id);
                if (credit) {
                    const month = credit.months.find(m => m.id === state.selectMonth?.id);
                    if (month) state.selectMonth = month;
                }
            })
            .addCase(fetchShippingMethodsThunk.fulfilled, (state, action) => {
                state.shipping.shippingMethods = action.payload;
                state.shipping.selectShippingMethod = state?.shipping?.selectShippingMethod || null;
            })
            .addCase(createOrderThunk.pending, handleLoader)
            .addCase(createOrderThunk.rejected, handleError)
            .addCase(createOrderThunk.fulfilled, handleRedirect)
            .addCase(sendPhoneCodeThunk.rejected, handleError)
            .addCase(sendPhoneCodeThunk.fulfilled, (state, action) => {
                state.isShowConfirmedPhone = true;
                state.temporaryPhone = action.payload.phoneNumber;
            })
    }
});

export const {
    setProductId,
    setCredit,
    setMonth,
    toggleService,
    nextPage,
    prevPage,
    setAvanse,
    saveUser,
    setShippingMethod,
    setTotal,
    setAddress,
    setCity,
    setShippingZone,
    setShippingPickup,
    togglePopup,
    openCredit,
    setConfirmedPhone,
    changeConfirmedPhone,
    setMarketing,
    setTerms,
    setContactMethod,
    setShipping,
    selectSubscription,
    setStarnetRegion,
    setStarnetCity,
    setStarnetAddress,
} = creditSlice.actions;

export default creditSlice.reducer;
